import { brandsOpenApi } from '@constants';
import { axiosBoa } from '@utils';
import { getParent, types } from 'mobx-state-tree';
import { createStoreAction } from './utils';

export const ForgotPasswordStore = types
    .model('ForgotPasswordStore', {
        pending: types.maybeNull(types.boolean)
    })
    .views((self) => ({
        get root() {
            return getParent(self);
        }
    }))
    .actions((self) => {
        const action = createStoreAction(self);

        return {
            sendForgotPasswordLink: action(
                function* sendForgotPasswordLink({ data, onSuccess = () => null }) {
                    self.pending = true;

                    yield axiosBoa.post(brandsOpenApi.forgotPassword.request, data);
                    onSuccess();
                },
                { onFinally: () => (self.pending = false) }
            ),
            resetPassword: action(
                function* resetPassword({ token, data, onSuccess = () => null }) {
                    self.pending = true;

                    yield axiosBoa.post(brandsOpenApi.forgotPassword.confirm(token), data);
                    onSuccess();
                },
                { onFinally: () => (self.pending = false) }
            )
        };
    });
